import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const contractWeightOverrideInDepartedCallHardRule: StowageRuleBM = {
    id: StowageRuleId.ContractWeightOverrideInDepartedCallHardRule,
    name: 'A cargo operation with an active contract weight override cannot be in a departed port call.',
    lastUpdatedUtc: '2025-10-29T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Is contract weight edited',
                            fieldPath: 'isContractWeightEdited',
                            type: 'boolean',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Reference value',
                            type: 'boolean',
                            referenceValue: 'true',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.CargoOperation,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Is port call departed',
                            fieldPath: 'isPortCallDeparted',
                            type: 'boolean',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Reference value',
                            type: 'boolean',
                            referenceValue: 'true',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.CargoOperation,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'Contract weight override active in departed call - Update IMOS to match edited weight, or remove override before departure',
    },
};
